import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=4abe1981&scoped=true"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"
import style0 from "./templates.vue?vue&type=style&index=0&id=4abe1981&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe1981",
  null
  
)

export default component.exports